import type { Message } from '../../types/agent';

export function ToolStatusBubble({ message }: { message: Message }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-[#F7F7F7] text-[#8696A0] text-[13px] italic rounded-[6px] px-2 py-1.5 max-w-[60%] wa-tool-status-enter"
    >
      {message.text}
    </div>
  );
}
